import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrModificationStatus.ts
var t = () => e("modificationStatus");
//#endregion
export { t as useTrModificationStatus };
